<!-- 影院中电影场次-->

<template>
  <div class="root-wrap fx-column">
    <div class="header-wrap">
      <div class="cinema_info-wrap--wrap">
        <div class="cinema_info-wrap fx-row fx-between">
          <div class="cinema_info_txt fx-around">
            <div class="cinema_name">{{ cinemaInfo.name }}</div>
            <div class="cinema_address">{{ cinemaInfo.address }}</div>
            <div class="cinema_rooms fc-tips">{{ cinemaInfo.roomnames }}</div>
          </div>
          <div class="cinema_location fx-middle" @click="toLocationView">
            <van-image :src="require('@/assets/images/location_icon.png')" width="50" height="50"></van-image>
          </div>
        </div>
      </div>
      <div class="cinema_movie-wrap">
        <movie-swipe v-model="activeIndex" :list="hotMovieList" ref="swipe"></movie-swipe>
        <div v-if="movieTemp != null">
          <div class="movie_name-wrap fx-center-middle fx-row">
            <span class="movie_name">{{ movieTemp.name }}</span>
            <span v-show="movieTemp.rating && movieTemp.rating > 0" class="movie_rate">{{ movieTemp.rating }}</span>
          </div>
          <div class="movie_actor fx-center fx-row fx-middle fc-tips">
            <div>
              <span>{{ movieTemp.duration }}分钟</span>
              <span>/</span>
              <span>{{ movieTemp.type }}</span>
              <span>/</span>
              <span>{{ movieTemp.actors }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="body-wrap fx-fill">
      <div class="fill-box">
        <div class="movie_session-empty-wrap fx-center-middle" v-if="movieDateList.length < 1">
          <div class="fs-14" style="margin-top: 16px">无可观影场次 ..</div>
        </div>

        <van-tabs v-if="movieDateList.length > 0" v-model="activeDateIndex"
          :color="$config.style.primaryColor"
          :scrollspy="false" lazy-render sticky :ellipsis="false"
          @click="switchDate" animated>
          <van-tab v-for="(item, index) in movieDateList" :key="index" :title="$getCalendar(item, 3, 2)">
            <div v-if="!loadingSession && movieSessionEmpty" class="movie_session-wrap">
              <div class="movie_session-empty-wrap fx-center-middle">
                <div class="fs-14">今日无可观影场次</div>
                <div v-if="movieDateList.length > 1">
                  <van-button style="padding: 10px 50px;" size="small" @click="doChangeMovieDate">看看其他日期</van-button>
                </div>
              </div>
            </div>
            <div v-else-if="!movieSessionEmpty" class="movie_session-wrap">
              <div class="movie_session-item--wrap h06-py-session-item-click" v-for="(item, index) in movieSessionList" :key="index" @click="selectMovieSession(item)">
                <div class="fx-center-middle">
                  <span class="fs-14 info_time">{{ item.playtime | formatDateToTime }}</span>
                  <span class="fc-tips">{{ item.closetime | formatDateToTime }}散场</span>
                </div>
                <div class="fx-center-middle">
                  <span class="fs-12 van-ellipsis">{{ item.edition }}</span>
                  <span class="fc-tips">{{ item.roomname }}</span>
                </div>
                <div class="fx-center-middle" :class="item.sdremark ? 'price_remark' : ''">
                  <template v-if="item.sdid">
                    <span class="fs-14 fc-active">{{ item.sdprice | formatIntToMoney }}</span>
                    <span class="fc-tips td-line">原价 {{ item.showPrice | formatIntToMoney }}豆</span>
                    <span v-if="item.sdremark" class="fc-tips" style="transform: scale(0.8)">{{ item.sdremark }}</span>
                  </template>
                  <template v-else-if="item.areaMinprice">
                    <span class="fs-14 fc-active">{{ item.areaMinprice| formatIntToMoney }}起</span>
                  </template>
                  <template v-else>
                    <div>
                      <span class="fs-14 fc-active">{{ item.showPrice| formatIntToMoney }}</span>
                      <span class="price-suffix">起</span>
                    </div>
                  </template>
                </div>
                <div class="fx-center-middle">
                  <van-button :color="$config.style.primaryColor" size="small" class="h06-py-session-select-seat">选 座</van-button>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <div class="utils-wrap">
    </div>
  </div>
</template>

<script>
import MovieSwipe from "@/components/cinema/movie-swipe";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      cinemaId: this.$route.query.cinemaId,
      movieId: this.$route.query.movieId,
      cinemaInfo: {},
      hotMovieList: [],
      activeIndex: -1,
      movieTemp: null,
      movieDateList: [],
      activeDateIndex: -1,
      movieSessionList: [],
      loadingSession: false
    };
  },

  computed: {
    ...mapGetters([
      "currentCityCode"
    ]),
    movieSessionEmpty() {
      return this.movieSessionList.length > 0 ? false : true;
    }
  },

  watch: {
    activeIndex: {
      handler(val) {
        if (this.hotMovieList && this.hotMovieList.length > 0) {
          //切换热映电影 清空场次日期信息 清空时间场次信息
          this.movieTemp = this.hotMovieList[val];
          this.movieDateList = [];
          this.movieSessionList = [];
          this.activeDateIndex = -1;
        }
      }
    },

    movieTemp: {
      handler(val) {
        if (val) {
          // 300毫秒防抖请求 当前选中电影的放映日期
          this.$common.debounce(this.switchMovie, 300);
        }
      }
    }
  },

  methods: {
    // 点击场次 去选座
    selectMovieSession(item) {
      budo_log.info("#149 selectMovieSession, 点击场次 去选座", item)

      // 将场次的信息 赋值到cookies 用于在选座时展示部分数据 0为 退出浏览器即清除信息;
      this.$cookies.set(this.$config.const.KEY_CURRENT_MOVIE, Object.assign({}, item, { logo: this.movieTemp.logo }), "0");
      this.$goPage("cinema-seat", {
        cinemaName: this.cinemaInfo.name
      });
    },

    //根据放映日期获取电影的场次
    getMovieSessionList() {
      return new Promise((resolve, reject) => {
        const loadingToast = this.$toast.loading(this.$config.loadingMsg);
        if (this.movieTemp) {
          let params = {
            movieid: this.movieTemp.id,
            cinemaid: this.cinemaId,
            playdate: this.movieDateList[this.activeDateIndex]
          };
          this.$service.movie_opi_list(params).then((res) => {
            this.movieSessionList = res.opiList;
            loadingToast.clear();
            this.loadingSession = false;

            resolve();
          }).catch((error) => {
            loadingToast.clear();
            this.loadingSession = false;
            reject();
          });
        }
      });
    },

    // 根据所选电影获取影院电影场次日期
    getMovieCinemaDateList() {
      return new Promise((resolve, reject) => {
        if (this.movieTemp) {
          let params = {
            movieid: this.movieTemp.id,
            cinemaid: this.cinemaId
          };
          this.$service.getMovieCinemaDateList(params).then((res) => {
              this.movieDateList = res.dateList;
              resolve(this.movieDateList);
          }).catch((error) => {
              error = '获取电影场次日期失败';
              budo_log.info("#190 getMovieCinemaDateList",error);
              reject(error);
          })
        }
      });
    },

    // 获取影院信息
    getCinemaDetail() {
      let params = {
        cinemaid: this.cinemaId
      };
      this.$service.getCinemaDetail(params).then((res) => {
        this.cinemaInfo = res.data.cinema;
        if (this.cinemaInfo.name) {
          this.$documentTitle(this.cinemaInfo.name);
        }
      });
    },

    // 根据影院获取当前热映电影
    getHotMovieList() {
      return new Promise((resolve) => {
        let params = {
          citycode: this.currentCityCode,
          cinemaid: this.cinemaId
        };
        this.$service.getHotMovieList(params).then((res) => {
          this.hotMovieList = res.data.movieList;
          resolve();
        });
      });
    },

    // 切换电影时的业务操作 这里业务操作整合 防止Vue监听事件触发导致数据获取错误 而不使用watch获取数据
    switchMovie() {
      const loadingToast = this.$toast.loading(this.$config.loadingMsg);
      this.getMovieCinemaDateList().then(() => {
        // 切换电影后获取了场次日期信息,再根据日期信息获取时间场次
        this.getMovieSessionList().then(() => {
          loadingToast.clear();
        }).catch(() => {
          loadingToast.clear();
        });
      });
    },

    // 手动切换电影的放映日期业务操作
    switchDate() {
      this.movieSessionList = [];
      this.loadingSession = true; //该变量用于控制加载时 不显示空状态
      this.$common.debounce(this.getMovieSessionList, 300);
    },

    // 当前日期场次为空 点击其他日期被动切换日期
    doChangeMovieDate() {
      let movieDateLength = this.movieDateList.length;
      if (this.activeDateIndex != movieDateLength - 1) {
        this.activeDateIndex++;
      } else {
        this.activeDateIndex = 0;
      }
      this.switchDate();
    },

    toLocationView() {
      if (this.cinemaInfo && Object.keys(this.cinemaInfo).length > 0) {
        this.$goPage("location-view", {
          name: this.cinemaInfo.name,
          address: this.cinemaInfo.address,
          lon: this.cinemaInfo.lon,
          lat: this.cinemaInfo.lat
        });
      }
    },

    // 初始化页面时获取热映电影 如果通过某电影进来的 优先查询 这里有查询防抖 故watch的movieTemp不会多次查询
    initPage() {
      this.activeIndex = -1;
      this.getCinemaDetail();
      this.getHotMovieList().then(() => {
        this.movieTemp = this.hotMovieList && this.hotMovieList.length > 0 ? this.hotMovieList[0] : null;
        if (this.movieId) {
          let movieIndex = -1;
          this.hotMovieList.forEach((item, index) => {
            if (item.id == this.movieId) {
              movieIndex = index;
              this.$refs.swipe.selectMovie(index);
            }
          });
          if (movieIndex == -1) {
            this.$toast.allowMultiple();
            this.$toast({
              message: "该影院无选中的影片，其他影片一样精彩哦~",
              duration: 3000
            });
          }
        }
      });
    }
  },

  mounted() {
    this.initPage();
  },

  components: {
    MovieSwipe
  }
};
</script>

<style lang="scss" scoped>
.price-suffix {
  padding-left: 5px;
  color: #cd5c5c;
}

.header-wrap {
  background: linear-gradient(180deg, #3f4956 0%, #fff 65%);

  .cinema_info-wrap--wrap {
    padding: 15px;
    padding-top: 20px;
    padding-bottom: 2px;

    .cinema_info-wrap {
      background-image: url("~@/assets/images/info_bg.png");
      background-size: cover;
      border-radius: 4px;
      background-position: center;
      padding: 10px 8px;

      .cinema_info_txt {
        > div {
          padding: 3px 0;
        }

        .cinema_name {
          // font-family: "pf medium";
          font-size: 18px;
        }

        .cinema_address {
          color: $second-color;
        }
      }

      .cinema_location {
        padding: 8px;
      }
    }
  }

  .cinema_movie-wrap {
    padding: 12px 0;
    padding-bottom: 8px;

    .movie_name-wrap {
      padding: 8px 0;

      span {
        display: inline-block;
        padding: 2px 6px;
      }

      .movie_name {
        font-size: 15px;
        // font-family: "pf medium";
        color: $second-color;
      }

      .movie_rate {
        font-size: 15px;
        color: $active-color;
      }
    }

    .movie_actor {
      font-size: 12px;

      > div {
        @include txt-ellipsis();
        max-width: 66%;
      }
    }
  }
}

.body-wrap {
  position: relative;

  .movie_session-wrap {
    background-color: $bg-light-color;
    padding: 0px 8px;
    padding-bottom: 10px;

    .movie_session-item--wrap {
      height: 70px;
      display: grid;
      grid-template-columns: 25% 28% 28% 19%;
      background-color: #fff;
      border-radius: 4px;
      padding: 8px 0;
      margin: 8px 0;

      > div {
        > span {
          @include txt-ellipsis();
          display: inline-block;
          padding: 1px 0;
          width: 100%;
          text-align: center;
        }

        &.price_remark span {
          padding: 0;
        }

        .info_time {
          font-weight: 700;
          color: $second-color;
          // font-family: "pf medium";
        }
      }
    }

    .movie_session-empty-wrap {
      margin: 8px 0;
      padding: 20px;
      background-color: #fff;
      border-radius: 4px;

      > div {
        padding: 5px 0;
      }
    }
  }
}

/deep/ .van-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;

  .van-tabs__content {
    flex: 1;

    .van-tab__pane {
      height: 100%;
      overflow-y: scroll;
    }
  }
}
</style>
